<template>
  <div>
    <v-container fluid grid-list-xs class="pa-0 tab-2nd hidden-lg-only">
      <v-tabs touchless v-model="tabs" fixed-tabs color="" class="w-100 pa-0 white card-r pa-1">
        <v-tab href="#booked" class="tabs w-50" >
          <span class="f-12 text-capitalize">Booked</span>
        </v-tab>
        <v-tab href="#requests" class="tabs pt-0 w-50">
          <span class="f-12 text-capitalize">Attendance Requests </span>
        </v-tab>
      </v-tabs>
      <v-tabs-items touchless v-model="tabs" class="tabs" >
        <v-tab-item id="booked" key="1" class="">
          <v-flex lg6 sm6 xs12 class="px-0 mt-2">
            <v-card class="pa-2 card-r grey lighten-4">
              <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
                <div class="text-xs-left f-17 text-capitalize">Booked classes</div>
              </v-toolbar>
               
              <v-list three-line class="pa-0 transparent" style="height: 65vh!important; overflow-y: scroll">
                <template v-for="(item, index) in bookedClass">

                  <v-subheader class="justify-center"
                               v-if="item.header"
                               :key="item.header"
                  >
                    {{ item.header }} 
                  </v-subheader>

                  <v-list-tile class="shadow-1 card-r white mt-2 pa-1" :key="item.title" avatar @click="">
                    <v-list-tile-avatar class="pa-0 ma-0">
                      <v-avatar size="40" color="blue-grey pa-0 ma-0 lighten-4">
                        <img v-bind:src="item.student_image" class="objec-fit">
                      </v-avatar>
                    </v-list-tile-avatar>

                    <v-list-tile-content class="pa-0 f-12">
                      <v-list-tile-title class="pa-0 f-13 font-weight-bold" v-html="item.student_name"></v-list-tile-title>
                      <v-list-tile-sub-title class="f-12 font-weight-bold word-break" v-html="item.module_name"></v-list-tile-sub-title>
                      <v-list-tile-sub-title class="f-12"><span class='text-grey word-break'>{{ item.booking_date }}</span>
                        <span class="font-weight-bold text-danger">At {{ item.booking_time }} </span></v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action right>
                      <!--<v-dialog class="pa-0 hidden-xs-only hidden-sm-only hidden-md-only display-unset" v-model="dialog2" width="500">-->
                      <!--<v-btn @click="ChangeTimePopup(item.id,item.package_id)" slot="activator" round-->
                      <!--class="text-capitalize f-12 ma-0 mb-1 text-primary shadow-1" flat small>change time</v-btn>-->
                      <!--</v-dialog>-->

                      <!-- <v-btn slot="activator" round
                             class="text-capitalize px-2 f-12 ma-0 mb-1 text-primary shadow-1" flat small
                             @click="ChangeTimePopup(item.module_id,item.package_id,item.student_id,item)">Change Time</v-btn>
                      <v-btn slot="activator" round
                             class="ma-0 grey--text mt-1 px-2 f-12 shadow-1 text-capitalize" flat small
                             @click="cancelBookPopup(item)" small color="blue">Cancel Class</v-btn> -->
                    </v-list-tile-action>

                    <!--v-show="!seen" v-on:click='seen = !seen'-->

                    <!--<v-btn v-show="seen" v-on:click='seen = !seen' small class="primary no-shadow card-r">Delete</v-btn>-->
                  </v-list-tile>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-tab-item>
        <v-tab-item id="requests" key="2" class="">
          <v-flex lg6 sm6 xs12 class="px-0 mt-2">
            <v-card class="pa-2 card-r grey lighten-4">
              <v-toolbar class="tow-clor-grey card-r mb-2 shadow-1 pl-3 text-white">
                <div class="text-xs-left f-17 text-capitalize">Attendance Requests </div>
              </v-toolbar>
              <sign-request v-bind:teacher_id="teacher_id"/>
            </v-card>
          </v-flex>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <v-container fluid grid-list-md class="hidden-xs-only hidden-sm-only hidden-md-only pa-0">
      <v-layout row wrap class="">
        <v-flex lg6 sm6 xs12 class="">
        <v-card class="pa-2 card-r grey lighten-4">
            <v-toolbar class="tow-clor-grey card-r shadow-1 pl-3 text-white">
              <div class="text-xs-left f-17 text-capitalize">Booked classes</div>
            </v-toolbar>
          <v-list three-line class="pa-0 transparent" style="height: 65vh!important; overflow-y: scroll">
              <template v-for="(item, index) in bookedClass">

                <v-subheader class="justify-center"
                             v-if="item.header"
                             :key="item.header"
                >
                  {{ item.header }}
                </v-subheader>

                <v-list-tile class="shadow-1 card-r white mt-2 pa-1" :key="item.title" avatar @click="">
                  <v-list-tile-avatar class="">
                    <v-avatar color="blue-grey lighten-4">
                     <img v-bind:src="item.student_image" class="objec-fit">
                    </v-avatar>
                  </v-list-tile-avatar>

                  <v-list-tile-content class="pa-0 f-12">
                    <v-list-tile-title class="pa-0 f-13 font-weight-bold" v-html="item.student_name"></v-list-tile-title>
                    <v-list-tile-sub-title class="f-12 font-weight-bold" v-html="item.module_name"></v-list-tile-sub-title>
                    <v-list-tile-sub-title class="f-12"><span class='text-grey'>{{ item.booking_date }}</span>
                      <span class="font-weight-bold text-danger">At {{ item.booking_time }} </span></v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    
                    <v-btn slot="activator" round
                           class="text-capitalize px-2 f-12 ma-0 mb-1 text-primary shadow-1" flat small
                           @click="ChangeTimePopup(item.module_id,item.package_id,item.student_id,item)">Change Time</v-btn>
                    <v-btn slot="activator" round
                           class="ma-0 grey--text mt-1 px-2 f-12 shadow-1 text-capitalize" flat small
                           @click="cancelBookPopup(item)" small color="blue">Cancel Class</v-btn>
                  </v-list-tile-action>

                  <!--v-show="!seen" v-on:click='seen = !seen'-->

                  <!--<v-btn v-show="seen" v-on:click='seen = !seen' small class="primary no-shadow card-r">Delete</v-btn>-->
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex lg6 sm6 xs12 class="">
          <v-card class="pa-2 card-r grey lighten-4">
            <v-toolbar class="tow-clor-grey card-r mb-2 shadow-1 pl-3 text-white">
              <div class="text-xs-left f-17 text-capitalize">Attendance Requests</div>
            </v-toolbar>
            <sign-request v-bind:teacher_id="teacher_id"/>
            <!-- < v-bind:teacher_id="teacher_id" v-bind:teacher_id="teacher_id"/> -->
          </v-card>
        </v-flex>

        <!-- <v-dialog class="pa-0 hidden-xs-only hidden-sm-only hidden-md-only display-unset" v-model="dialog2" width="500">
                <v-btn @click="ChangeTimePopup(item.id,item.package_id)" slot="activator" round
                  class="text-capitalize f-12 ma-0 mb-1 text-primary shadow-1" flat small>change time</v-btn>
        </v-dialog> -->

      </v-layout>
    </v-container>

<v-dialog class="pa-0 hidden-xs-only hidden-sm-only hidden-md-only display-unset" v-model="dialog2" width="500">
    <v-card class="pa-2 card-r grey lighten-4">
        <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
          <div class="text-xs-left f-17 text-capitalize">Change Time</div>
          <v-spacer></v-spacer>
          <v-btn class="mr-2 tow-clor-1" icon @click="dialog2 = false">
            <v-icon class="text-white f-28">close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout row xs12 justify-center>
          <v-flex xs12 class="mt-2 f-12">
            Your Current Date & Time: <span class="font-weight-bold f-12">{{dialog2Data.booking_date}} - {{dialog2Data.booking_time}}</span>
          </v-flex>
          
          <v-divider></v-divider>
        </v-layout>
        <v-layout row xs12 justify-center>
            <v-flex xs12 class="mt-2 text-xs-center" v-if="alertType=='success'">
              <v-alert
                :value="true"
                color="success"
                icon="check_circle"
                outline
                v-model="msg"
              >
                {{msgText}}
              </v-alert>
            </v-flex>
            <v-flex xs12 class="mt-2 text-xs-center" v-if="alertType=='warning'">
              <v-alert
                :value="true"
                color="error"
                icon="warning"
                outline
              >
                {{msgText}}
              </v-alert>
            </v-flex>
        </v-layout>
          <v-layout row wrap class="pa-3" v-if="!loading">
            <v-flex d-flex xs12 class="card-r n">
              <v-menu
                ref="menu4"
                v-model="menu4"
                :close-on-content-click="true"
                :nudge-right="40"
                lazy
                class="card-r no-shadow"
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field outline
                  slot="activator"
                  v-model="selectedDate"
                  label="Select Date"
                  persistent-hint
                  placeholder="dd/mm/yyyy"
                  prepend-icon="event"
                ></v-text-field>
                <v-date-picker
                  @input="GetTime(selectedDate)"
                  :events="arrayEvents"
                  event-color="red"
                    :allowed-dates="getEnableList"
                  v-model="selectedDate"
                  no-title >
                </v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex d-flex xs12>
              <v-select outline
                :items="timeslot"
                item-text="time_from"
                item-value="id"
                v-model="selectedTime"
                class="input-group--focused"
                prepend-icon="alarm"
                placeholder="select your time"
                label="Starting Time"
              ></v-select>
            </v-flex>
            <v-flex d-flex xs12>
              <!-- {{dialog2Data}} -->
              <v-btn @click="updateClass(dialog2Data.student_id,selectedDate,selectedTime,dialog2Data.booking_id,dialog2Data.package_id,dialog2Data.module_id)" larg depressed
                      class="no-shadow card-r w-100 ma-0" color="primary">Update</v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="" v-if="loading" >
            <v-flex d-flex lg4 sm4 xs4>
              <div class="text-xs-center">
                <v-progress-circular
                  :size="50"
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
            </v-flex>
            <v-divider></v-divider>
          </v-layout>
  </v-card>
</v-dialog>

<v-dialog class="pa-0 hidden-xs-only hidden-sm-only hidden-md-only display-unset" v-model="dialog3" width="500">
                        <!-- <v-btn slot="activator" round flat class="ma-0 grey--text mt-1 f-12
                     shadow-1 text-capitalize" small>Cancel Class eee</v-btn> -->
                        <v-card class="pa-2 card-r grey lighten-4">
                          <div class="pa-2">
                            <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
                              <div class="text-xs-left f-15 text-capitalize">Are you sure to cancel?</div>
                              <v-spacer></v-spacer>
                              <v-btn class="mr-2 tow-clor-1" icon @click="dialog3 = false">
                                <v-icon class="text-white f-28">close</v-icon>
                              </v-btn>
                            </v-toolbar>
                          </div>
                          <v-layout row xs12 justify-center class="pa-2">
                            <v-flex xs12 class="pl-2 mt-3 grey card-r py-3 text-white">
                              Your Current Date & Time : <span class="font-weight-bold f-12"> {{dialog3Data.booking_date}} - {{dialog3Data.booking_time}}</span>
                              <span class="ml-3 font-weight-bold">{{dialog3Data.booked_time}}</span>
                            </v-flex>
                          </v-layout>

                          <v-layout row xs12 justify-center class="pa-2">
                              <v-flex xs12 class="mt-2" v-if="alertType=='success'">
                                <v-alert
                                  :value="true"
                                  color="success"
                                  icon="check_circle"
                                  outline
                                  v-model="msg"
                                >
                                  {{msgText}}
                                </v-alert>
                              </v-flex>
                              <v-flex xs12 class="mt-2" v-if="alertType=='warning'">
                                <v-alert
                                  :value="true"
                                  color="error"
                                  icon="warning"
                                  outline
                                >
                                  {{msgText}}
                                </v-alert>
                              </v-flex>
                          </v-layout>

                          <v-layout row wrap class="mt-3" v-if="!loading">
                            <v-flex d-flex lg12 sm12 xs12>
                              <v-btn v-if="!msg" @click="cancelBooking(dialog3Data.booked_id)" larg depressed
                                     class="card-r w-100" color="primary darken-2">Yes</v-btn>
                              <v-btn @click="dialog3=false" larg depressed class="card-r text-white w-100" color="grey">Close</v-btn>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap class="" v-if="loading" >
                            <v-flex d-flex lg12>
                              <div class="text-xs-center">
                                <v-progress-circular
                                  :size="50"
                                  indeterminate
                                  color="primary"
                                ></v-progress-circular>
                              </div>
                            </v-flex>
                            <v-divider></v-divider>
                          </v-layout>
                        </v-card>
                      </v-dialog>

    
  </div>
</template>
<script>
  /* eslint-disable */
  import { mapState } from "vuex";
  import SignRequest from './SignRequest'

  export default {
    data () {
      return {
        tabs: "booked",
        show: true,
        module_description:[],
        classDetails:[],
        seen: true,
        loading:false,
        msgText:'',
        alertType:'',
        msg:false,
        loading:'',
        dialog:false,
        dialog1:false,
        menu4:'',
        menu1:'',
        date:'',
        allowedDates:{
          date_from:'',
          date_to:''
        },
        arrayEvents:[],
        getEnableList:[],
        timeslot:'',
        selectedDate:'',
        selectedTime:'',
        dateFormatted:'',
        bookedClass: [],
        unBookedClass: [],
        pastClasses:[],
        cancel_for:'',
        dialog2Data:'',
        dialog2:'',
        dialog3Data:'',
        dialog3:'',
        items: [

          // { header: 'BOOKED CLASSES', header1: 'UNBOOKED CLASSES' },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            avatar1: 'https://cdn.vuetifyjs.com/images/lists/1.jpg',
            title1: 'student name',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig..."
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg',
            title1: 'student name',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig..."
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
            title1: 'student name',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig..."
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg',
            title1: 'student name',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig...?"
          },
          { divider: true, inset: true },
          {
            avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg',
            title1: 'student name',
            title: 'Not Booked',
            subtitle: "<span class='text--primary'>DATE & TIME </span> &mdash; some describtions for this class or somthig..."
          }
        ],
        teacher_id:''
      }
    },
    beforeCreate:function(){
      var teacher_id = this.$route.params.id;
      this.teacher_id=teacher_id
      // console.log(teacher_id)
      Store.dispatch('getTeacherClasses', teacher_id);
    },
    created:function(){
      var teacher_id = this.$route.params.id;
      this.teacher_id=teacher_id
    },
    watch:{
      teacherClass:function(){
          this.setClasses()
      }
    },
    mounted: function () {
        
    },
    methods:{
      setClasses(){
        var classDetails = this.teacherClass;
        this.bookedClass = classDetails.booked_classes;
        this.unBookedClass = classDetails.non_booked_classes;
        this.pastClasses = classDetails.past_classes;
      },
      ChangeTimePopup(moduleId,packageId,studentId,item){
        this.dialog2=true
        this.dialog2Data=item
        this.msg=false
        this.msgText=""
        this.alertType=""
        this.loading=true
        this.arrayEvents=[]
        let student_id=studentId
        let module_id=moduleId
        let package_id=packageId

        // student_id=9
        // module_id=22
        // package_id=5
        this.timeslot=[]
        let data={
          'student_id':parseInt(student_id),
          'module_id':module_id,
          'package_id':package_id
        }
        Store.dispatch("Students/getTeacherTime",data)
          .then(res=>{
            // debugger
            if(res.status==204){
              this.loading=false
              this.msgText="No another time for change your module time"
              this.alertType="warning"
              this.msg=true
            }else if(res.status==203){
              this.loading=false
              this.msgText="Not buy this package."
              this.alertType="warning"
              this.msg=true
            }else if(res.status==200){
              setTimeout(() => {
                var teacherTime=Store.state.Students.teacherTime
                this.teacherTime=teacherTime
                this.allowedDates.date_from=teacherTime.date_from
                this.allowedDates.date_to=teacherTime.date_to
                this.selectedDate=this.allowedDates.date_from
                this.date_from=this.allowedDates.date_from
                this.date_to=this.allowedDates.date_to
                this.loading=false
                this.alertType=""
                this.msgText=""
                this.msg=false
                this.arrayEvents=[]
                const response=res.data
                for(var x=0;x<response.times.length;x++){
                  for(var y=0;y<response.times[x].length;y++){
                    var date=response.times[x][y].date
                    this.arrayEvents.push(date)
                  }
                }
              }, 500);
            }else if(res.response.status==404){
              this.loading=false
              this.msgText=res.response.data.error.message
              this.alertType="warning"
              this.msg=true
            }
          }).catch((error)=>{
            
          alert("error")
        })
      },
      GetTime(selectedDate){
        this.timeslot=''
        // //below comment lines are filter time from day
        //  var date = new Date(selectedDate);
        //  var day = date.getDay()
        //   switch(day){
        //     case 1:day="MON";break;
        //     case 2:day="TUE";break;
        //     case 3:day="WED";break;
        //     case 4:day="THU";break;
        //     case 5:day="FRI";break;
        //     case 6:day="SAT";break;
        //     case 7:day="SUN";break;
        //   }
        //   // for(var x=0)
        // var time=[];
        //  for(var x=0;x<this.teacherTime.times.length;x++){
        //    if(this.teacherTime.times[x][0].day==day){
        //      for(var y=0;y<this.teacherTime.times[x].length;y++){
        //        var Data={
        //          "time_from":this.teacherTime.times[x][y].time_from,
        //          "id":this.teacherTime.times[x][y].id
        //        }
        //        time.push(Data)
        //      }
        //      break;
        //    }
        //  }

        var time=[];
        console.log(this.teacherTime.times.length)
        for(var x=0;x<this.teacherTime.times.length;x++){
          for(var y=0;y<this.teacherTime.times[x].length;y++){
            if(this.teacherTime.times[x][y].date==selectedDate){

              var Data={
                "time_from":this.teacherTime.times[x][y].time_from,
                "id":this.teacherTime.times[x][y].id
              }
              time.push(Data)
            }
          }
        }

        this.timeslot=time


      },
      updateClass(studentId,selectedDate,teacherBookingId,studentBookingId,packageId,moduleId){
        this.loading=true
        var data={
          student_id:studentId,
          module_id:moduleId,
          package_id:packageId,
          teacher_bookings_id:teacherBookingId,
          student_bookings_id:studentBookingId
        }
        Store.dispatch("Students/adminUpdateStudentBookedClass",{data})
          .then(res=>{
            if(res.status==201){
              this.loading=false
              this.msg=true
              this.msgText="Booking Successfully"
              this.alertType="success"
              setTimeout(() => {
                this.dialog=false
                this.loading=false
                this.msg=false
              }, 1000);
            }
          })

      },

      cancelBookPopup(item){
        this.dialog3=true
        this.dialog3Data=item
      },

      cancelBooking(BookingId){
        var Data={
          "student_bookings_id":BookingId,
          "cancel_for":this.cancel_for
        }
        if(this.cancel_for){
          Store.dispatch("Teachers/cancelBookedClass",Data)
            .then(res=>{
              if(res.status==201){
                this.loading=false
                this.msgText="You are successfully cancelled the booking"
                this.alertType="success"
                this.msg=true
                setTimeout(() => {
                  this.dialog=false
                  this.loading=false
                  this.msgText=""
                  this.alertType=""
                  this.msg=false
                }, 1000)
              }else{
                this.loading=false
                this.msgText="You can not cancel the booking"
                this.alertType="warning"
                this.msg=true
                setTimeout(() => {
                  this.dialog3=false
                  this.loading=false
                  this.msgText=""
                  this.alertType=""
                  this.msg=false
                }, 1000)
              }

            }).catch((error)=>{
            this.alertType="warning"
            this.msgText="Error"
            // alert(error)
          })

        }
      },
    },
    computed:{
      ...mapState([
        'teacherClass'
      ])
    },
    components: {
      SignRequest,
    }
  }
</script>
<style>
  /*.tab-2nd .v-tabs__container {*/
  /*height: 25px!important;*/
  /*}*/
</style>





// WEBPACK FOOTER //
// src/components/profile/teacher/TeacherClasses.vue